<div [@routerTransition]>
  <!--<div class="row row-style-card">
    <a (click)="AddNewPatient()" class="nav-link-hand patientreg-link row-card-a margin-bottom-8px" title="Click here for New Registration" *ngIf="ShowRegister"><i class="fas fa-plus font-size-11 margin-right-3px"></i>Register</a>
    <a class="nav-link-hand new-button3" title="Back To Profile" (click)="BackToProfile()" *ngIf="Showarrow"><i class="fas fa-angle-double-left font-size-19px"></i> Back</a>
  </div>-->
  <!--<a class="nav-link-hand new-button3" title="Back To Profile" (click)="BackToProfile()" *ngIf="Showarrow"><i class="fas fa-angle-double-left font-size-19px"></i> Back</a>-->
  <div class="card my-profile-form margin-top-15px top-link">
    <div class="card-header wh-header padding-bottom-0px height-47px">
      <div class="row">
        <div class="col-md-2">
          Catalogue
        </div>
        <div class="col-md-8 padding-right-0px">
          <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)" class="margin-right-3px"></search-list>
          <!--<div class="row">

            <div class="col-md-8 float-right padding-right-0px padding-l-0px display-inherit">

              <button type="button" class="btn actions-btn-prime float-right font-size-13px" (click)="Data()" *ngIf="displaylist">Proceed</button>
            </div>
          </div>-->
        </div>
        <div class="col-md-2">
          <button type="button" (click)="Data()" class="button-service-save font-size-18px  nav-link-hand margin-left-3px float-right" title="Proceed"><i class="fas fa-shopping-cart"></i><div class="badge badge-catalogue"><h4 class="margin-bottom-4px margin-top-4px" *ngIf="length">{{length}}</h4></div></button>
        </div>
      </div>

    </div>
    <div class="card-body padding-top-0px">

      <div class="row" *ngIf="displaylist">
        <div class="col-md-2 padding-top-5px padding-bottom-5px padding-left-10px padding-right-10px" *ngFor="let l of pdata">
          <div class=" card  height-100pe background-catalogue box-shadow-catalogue card-catalogue">
            <div class="card-body padding-left-0px padding-right-0px padding-top-0px padding-bottom-0px margin-left-0px">
              <div class="row">
                <div class="col-md-12 text-align-center padding-left-0px padding-right-0px">
                  <img src="dummy.jpg" class="nav-link-hand image-width-catalogue padding-top-5px padding-bottom-5px" />
                </div>
              </div>

              <div class="">
                <div class="row margin-left-3px margin-right-0px">
                  <div class="col-md-12">
                    <h4 class="margin-bottom-0px  font-size-12px margin-left-3px font-weight-normal">{{l.ServiceName}}</h4>
                  </div>

                </div>
                <div class="row margin-left-3px margin-right-0px padding-top-5px padding-bottom-5px">
                  <div class="col-md-12">
                    <h4 class="margin-bottom-0px  font-size-12px margin-left-3px font-weight-normal">Pack : Kilogram</h4>
                  </div>

                </div>
                <div class="row margin-left-3px margin-right-0px">
                  <div class="col-md-12">
                    <h4 class="margin-bottom-0px  font-size-14 margin-left-3px font-weight-bold"><i class="fas fa-rupee-sign font-size-12px"></i> {{l.BasePrice}}</h4>
                  </div>

                </div>
              

              </div>
            </div>
            <div class="card-footer padding-top-0px padding-bottom-0px">
              <div class="row margin-top-3px" *ngIf="l.Quantity== null">
                <div class="col-md-12 padding-right-5px padding-bottom-5px">
                  <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-5px float-right" (click)="ViewPatientDetails(l)"> <i class="fas fa-plus "></i> Add</button>
                </div>
              </div>
              <div class="row" *ngIf="l.Quantity > 1 || l.Quantity == 1">
                <div class="offset-md-3 col-md-1 margin-top-auto margin-bottom-auto">
                  <a (click)="IncrementDate(l)" title="Previous" class="nav-link-hand">
                    <i class="fas fa-plus-circle margin-top-3px font-size-24px"></i>

                  </a>
                </div>


                <div class="col-md-4 col-sm-4 padding-right-0px">
                  <div class="date-form">
                    <input type="text" class="form-control border-top-0 border-left-0 border-right-0 border-bottom-0px border-radius-2px  data-color-new" placeholder="Qty"
                           name="l.Quantity" [(ngModel)]="l.Quantity" #Quntity2="ngModel">




                  </div>



                </div>
                <div class="col-md-1 margin-top-auto margin-bottom-auto padding-left-8px padding-right-19px">
                  <a (click)="DecrementDate(l)" title="Next" class="nav-link-hand">
                    <i class="fas fa-minus-circle margin-top-3px font-size-24px"></i>

                  </a>
                </div>

              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="row" *ngIf="!displaylist">
        <div class="col-md-12">
          <div class="table-component">
            <div class="table-responsive overflow-x">


              <table class="table table-striped margin-left-20p table-fixed"
                     cols="auto,2*,*,*,*,*,*,*">

                <thead class="">
                  <tr>

                    <th class="min-width-24px padding-top-4px padding-bottom-4px th-sticky">
                      #
                    </th>


                    <th class="padding-top-4px padding-bottom-4px th-sticky">
                      Service Description
                    </th>
                    <th class="padding-top-4px padding-bottom-4px th-sticky">
                      QTY
                    </th>

                    <th class="text-align-center padding-top-4px padding-bottom-4px th-sticky">
                      Unit Price
                    </th>

                    <th class="padding-top-4px padding-bottom-4px th-sticky">
                      Discount
                    </th>

                    <th class="text-align-center padding-top-4px padding-bottom-4px th-sticky">
                      Item Rate
                    </th>
                    <!--<th class="">

                </th>-->
                    <th class="padding-top-4px padding-bottom-4px th-sticky">

                    </th>






                  </tr>
                </thead>

                <tbody class="table-body">
                  <tr *ngFor="let l of CurrentBillDetails;let i = index">


                    <td class="td-padding-tb">
                      {{i+1}}
                    </td>
                    <td class=" td-padding-tb">{{l.ServiceDescription}}</td>

                    <td class="text-align-center td-padding-tb">
                      <!--<input type="number" class="form-control text-align-right td-width-82px" placeholder=""
                  [(ngModel)]="l.quantity"
                  maxlength="2" required>-->
                      <label *ngIf="!l.Edit" class="margin-bottom-0px">{{l.Quantity}}</label>
                      <input *ngIf="l.Edit" type="number" class="form-control text-align-right td-width-82px" placeholder=""
                             [(ngModel)]="l.Quantity"
                             maxlength="2" required>
                    </td>
                    <td class="text-align-center td-padding-tb ">{{l.UnitPrice}}</td>

                    <td class="td-padding-tb text-align-center">
                      <input *ngIf="l.Edit" type="number" class="form-control text-align-right td-width-82px" placeholder=""
                             [(ngModel)]="l.discount"
                             maxlength="2" required>
                      <label *ngIf="!l.Edit" class="margin-bottom-0px">{{l.Discount}}</label>

                    </td>
                    <td class="td-padding-tb text-align-center"> <label>{{l.Quantity * l.UnitPrice}}</label></td>
                    <td class=" td-padding-tb ">

                      <!--<a class="nav-link-hand education-navlink font-size-16px color-Assign" title="Edit Plan" (click)="Editrow()" *ngIf="Add">
                    <span class="badge"><i class="fas fa-pencil-alt"></i></span>
                  </a>-->
                      <button type="submit" (click)="Editrow(l)" class="button-service-save font-size-16px color-secondary nav-link-hand margin-left-3px" title="Save" *ngIf="!l.Edit"><i class="fas fa-pencil-alt"></i></button>
                      <a (click)="delete(i)" class="nav-link-hand font-size-16px color-Rejected" title="Remove" *ngIf="!l.Edit"><i class="far fa-trash-alt nav-link-hand"></i></a>
                      <button type="submit" (click)="OnClear(l)" class="button-service-save font-size-16px color-secondary nav-link-hand" title="Save" *ngIf="l.Edit"><i class="far fa-save"></i></button>
                      <button type="submit" (click)="OnClear(l)" class="button-service-save font-size-16px  nav-link-hand color-Rejected" title="Save" *ngIf="l.Edit"><i class="fa fa-times"></i></button>

                    </td>



                  </tr>
                </tbody>



              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>



